import React from 'react';
import { Star } from 'lucide-react';
import { useStoreData } from '../hooks/useStoreData';

const Testimonials = () => {
  const { testimonials } = useStoreData();

  return (
    <section className="py-16 px-4 bg-white">
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4 uppercase tracking-wider">Let Customers Speak For Us</h2>
        <p className="text-center text-gray-600 mb-12">Real reviews from our valued customers</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} className="fill-[#c9a86a] text-[#c9a86a]" />
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">"{testimonial.comment}"</p>
              <div className="border-t border-gray-200 pt-4">
                <p className="font-semibold text-[#4a1a1f]">{testimonial.name}</p>
                <p className="text-sm text-gray-500">Purchased: {testimonial.product}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;